export function carrambaProductFiltersClient() {
    jQuery( function ( $ ) {
        const isMobile = window.matchMedia( "(max-width: 1023px)" );
        const shopDynamicSidebar = '.shop-dynamic-sidebar';
        const dropdownClass = '.attribute-filter-dropdown';
        const checkboxClass = '.wc-block-components-checkbox__input';
        const checkboxList = '.carramba-attribute-filter-list';
        const clearButton = '.carramba-attribute-filter-clear-button';
        const submitFiltersButton = '.carramba-product-filters-submit';

        $( document ).on( 'click', clearButton, function ( e ) {
            e.preventDefault();
            $( '.attribute-filter' ).addClass( 'is-loading' );
            const attribute = $( this ).data( 'filter' );
            const filterParam = 'filter_' + attribute;
            const filterTypeParam = 'query_type_' + attribute;
            const url = new URL( window.location.href );
            url.searchParams.delete( filterParam );
            url.searchParams.delete( filterTypeParam );
            window.location.href = url.href;
        } );

        $( shopDynamicSidebar ).on( 'change', '.attribute-filter-dropdown', function ( e ) {
            e.preventDefault();
            const term = $( this ).val();
            if (term === undefined) {
                return;
            }
            const attribute = $( this ).data( 'attribute' );
            const url = new URL( window.location.href );
            url.searchParams.set( 'filter_' + attribute, term );

            window.location.href = url.href;
        } );

        $( shopDynamicSidebar ).on( 'change', checkboxClass, function ( e ) {
            e.preventDefault();
            if (isMobile.matches) {
                return;
            }
            const attribute = $( this ).data( 'attribute' );
            const selectedTerms = [];
            $( `${ checkboxClass }[data-attribute="${ attribute }"]:checked` ).each( function () {
                selectedTerms.push( $( this ).val() );
            } );
            $( checkboxList ).addClass( 'opacity-50' );
            const url = new URL( window.location.href );
            url.searchParams.set( 'filter_' + attribute, selectedTerms.join( ',' ) );
            url.searchParams.set( 'query_type_' + attribute, 'or' );

            if (selectedTerms.length === 0) {
                url.searchParams.delete( 'filter_' + attribute );
                url.searchParams.delete( 'query_type_' + attribute );
            }

            $( '.attribute-filter' ).addClass( 'is-loading' );

            window.location.href = url.href;
        } );

        $( '.clear-filter' ).on( 'click', function ( e ) {
            e.preventDefault();
            const attribute = $( this ).data( 'attribute' );
            const url = new URL( window.location.href );
            url.searchParams.delete( 'filter_' + attribute );
            window.location.href = url.href;
        } );

        $( submitFiltersButton ).on( 'click', function ( e ) {
            e.preventDefault();
            const url = new URL( window.location.href );
            const selectedItems = $( '.carramba-attribute-filter-list input:checked' );

            url.searchParams.forEach( ( value, key ) => {
                if (key.includes( 'filter_' )) {
                    url.searchParams.delete( key );
                }
                if (key.includes( 'query_type_' )) {
                    url.searchParams.delete( key );
                }
            } );

            if (selectedItems.length === 0) {
                window.location.href = url.href;
                return;
            }
            const selectedItemsMapped = [];
            selectedItems.each( function () {
                const term = ($( this ).val());
                const attribute = $( this ).data( 'attribute' );

                const existingItem = selectedItemsMapped.findIndex( item => item.attribute === attribute );

                if (existingItem !== -1) {
                    selectedItemsMapped[existingItem].term = selectedItemsMapped[existingItem].term + ',' + term;
                    return;
                }

                selectedItemsMapped.push( {
                    attribute,
                    term
                } );
            } );
            selectedItemsMapped.forEach( ( { term, attribute } ) => {
                url.searchParams.set( 'filter_' + attribute, term );
                url.searchParams.set( 'query_type_' + attribute, 'or' );
            } );

            window.location.href = url.href;
        } );

    } ); // jQuery End
}
